import { UploadFileData } from './../../models/uploads';
import { DisplayNotificationService } from './../../shared/services/common/notification.service';
import { ReadConfigService } from './../../shared/services/common/read-config.service';
import { UploadService } from './../../shared/services/uploads/upload.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { SelectEvent, SuccessEvent, UploadEvent } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-other',
  templateUrl: './other.component.html',
  styleUrls: ['./other.component.css']
})
export class OtherComponent implements OnInit {

  config: any;
  allUploadIds = [];
  fileNameErrorMsg = '';
  msg = '';
  readonly uploadRemoveUrl: string = 'removeUrl';
  uploadSaveUrl: string;

  constructor(
    private authService: AuthService,
    private uploadService: UploadService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit() {
    this.config = this.readConfigService.getUploadFile();
    this.uploadSaveUrl = this.uploadService.getUploadUrl();
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

  uploadComplete(upload: any) {
    if (this.allUploadIds) {
      for (const allUploadId of this.allUploadIds) {
        upload.removeFilesByUid(allUploadId);
      }
      this.allUploadIds = [];
    }
  }

  uploadEventHandler(e: UploadEvent) {
    this.notificationService.setUpLoading(true);
    const files = e.files;
    for (const file of files) {
      const a = file.uid;
      if (a !== undefined) {
        this.allUploadIds.push(a);
      }
    }
    const data = new UploadFileData();
    data.fileType = 'Other';
    if (this.authService !== null && this.authService.currentUser !== null) {
      data.userId = this.authService.currentUser.Id.toString();
    }
    data.userInfo = JSON.stringify(this.uploadService.UserInfo());
    e.data = data;
  }

  uploadSuccess(e: SuccessEvent) {
    const response = e.response;
    if (response && response.body) {
      this.displayNotification(response.body);
    }
    this.notificationService.setUpLoading(false);
    e.preventDefault();
  }

  selectEventHandler(e: SelectEvent) {
    const fileName = (e.files[0].name).substring(0, e.files[0].name.lastIndexOf('.') + 1);
    if (fileName.length > 200) {
      this.fileNameErrorMsg = this.config.MaxFileNameErrorMsg;
      this.displayNotification({ success: false, message: this.fileNameErrorMsg });
      e.preventDefault();
    }
  }

  errorEventHandler() {
    this.msg = this.config.ErrorMessage;
    this.displayNotification({ success: false, message: this.msg });
    this.notificationService.setUpLoading(false);
  }

  displayNotification(response: any) {
    this.notificationService.setUpNotification(response);
  }

}
